import React from 'react';
import { UserProfileViewModel } from './UserProfileViewModel';
import { SetupUIBindingForReactFunctionalComponent } from '../common/UIBinding';

export function UserProfile(props: { viewModel: UserProfileViewModel }) {
    let viewModel = props.viewModel;
    SetupUIBindingForReactFunctionalComponent(props.viewModel);

    React.useEffect(() => {
        viewModel.initialize();

        return () => {            
        };
    }, []);

    return <div className="form">
    <div className="field"><div className="name">Nickname</div><div className="value"><input type="text" value={viewModel.nickname} onChange={e => viewModel.nickname = e.target.value} /></div></div>
    <div className="field"><div className="name"></div><div className="value"><button className="submit" onClick={() => viewModel.submit()}>Update</button></div></div>
    <div className="field"><div className="name"></div><div className="value alert">{viewModel.error}</div></div>
</div>;
}
